import React, { forwardRef, memo } from 'react'

const ClosureShape = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 321 560"
      fill="none"
      {...props}>
      <rect
        x="303.333"
        y="25.955"
        width="131.632"
        height="188.046"
        rx="65.816"
        transform="rotate(32.419 303.333 25.955)"
        stroke="#78BE20"
        strokeWidth={37.609}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="208"
        y="32"
        width="201"
        height="218">
        <rect
          x="303.333"
          y="25.955"
          width="131.632"
          height="188.046"
          rx="65.816"
          transform="rotate(32.419 303.333 25.955)"
          stroke="#78BE20"
          strokeWidth={37.609}
        />
      </mask>
      <g mask="url(#mask0)">
        <rect
          opacity={0.43}
          x="368.975"
          y="45.365"
          width="84.621"
          height="244.46"
          transform="rotate(32.419 368.975 45.365)"
          fill="#4A6C20"
        />
      </g>
      <rect
        x="137.214"
        y="533.057"
        width="131.632"
        height="188.046"
        rx="65.816"
        transform="rotate(-147.581 137.214 533.057)"
        stroke="#78BE20"
        strokeWidth={37.609}
      />
      <g opacity={0.43}>
        <mask
          id="mask1"
          maskUnits="userSpaceOnUse"
          x="33"
          y="310"
          width="200"
          height="218">
          <rect
            x="127.177"
            y="304.15"
            width="131.632"
            height="188.046"
            rx="65.816"
            transform="rotate(32.204 127.177 304.15)"
            stroke="#78BE20"
            strokeWidth={37.609}
          />
        </mask>
        <g mask="url(#mask1)">
          <rect
            x="192.89"
            y="323.314"
            width="84.621"
            height="244.46"
            transform="rotate(32.204 192.89 323.314)"
            fill="#4A6C20"
          />
        </g>
      </g>
      <path
        d="m249.473 272.988-35.716-22.683 35.284-55.558c6.264-9.863 19.337-12.781 29.2-6.517 9.863 6.264 12.78 19.337 6.517 29.2l-35.285 55.558Z"
        fill="#CEDC00"
      />
      <path
        d="m191.074 286.023 35.717 22.683-35.285 55.559c-6.264 9.863-19.337 12.78-29.2 6.517-9.862-6.264-12.78-19.337-6.516-29.2l35.284-55.559Z"
        fill="#CEDC00"
      />
      <path
        d="m273.11 294.964 35.341 5.737"
        stroke="#78BE20"
        strokeWidth={14.104}
      />
      <path
        d="m184.811 238.884-20.218-29.548"
        stroke="#78BE20"
        strokeWidth={14.104}
      />
      <path
        d="m137.499 251.999 35.34 5.737"
        stroke="#78BE20"
        strokeWidth={14.104}
      />
    </svg>
  )
)

ClosureShape.displayName = 'ClosureShape'
export default memo(ClosureShape)
